import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseModel from "./BaseModel";
import EDocument from "./EDocument";
var Application = /*#__PURE__*/function (_BaseModel) {
  function Application() {
    _classCallCheck(this, Application);
    return _callSuper(this, Application, arguments);
  }
  _inherits(Application, _BaseModel);
  return _createClass(Application, [{
    key: "status",
    value: function status() {
      switch (this.get('application_status_id')) {
        case -2:
        case -1:
          return 'Declined';
        case 0:
          return 'Pending Decision';
        case 1:
          return 'Pending Approval';
        case 2:
          return 'Approved';
        case 3:
          return 'Funded';
        case 4:
          return 'Awaiting Response';
        case 5:
          return 'Awaiting Work Verification';
        case 6:
          return 'About to be funded';
        case 7:
          return 'Ready for approval';
        default:
          return 'Unknown';
      }
    }
  }, {
    key: "isApproved",
    value: function isApproved() {
      return this.status() === 'Approved' && !this.isSigned();
    }
  }, {
    key: "isSigned",
    value: function isSigned() {
      return this.edocs().filter(function (edoc) {
        return edoc.isSigned();
      }).length > 0;
    }
  }, {
    key: "edoc",
    value: function edoc() {
      return this.edocs()[0];
    }
  }, {
    key: "edocs",
    value: function edocs() {
      return this.get('edocs').map(function (edoc) {
        return new EDocument(edoc);
      });
    }
  }]);
}(BaseModel);
export default Application;